@if ((isComposer && composerChanges?.length) || !isComposer) {
  <div class="comment" [class.hidden-from-view]="isHidden()"
    >
    @if (!isCommentEdited && hasComment && !isComposer && canEdit) {
      <div class="actions">
        @if (userId === history?.Creator.Id && history?.ActionName !== 'LEAD_TYPE') {
          <button (click)="onEdit()">
            <img class="edit-button" alt="Edit" src="/assets/icons/new/edit-gray.svg" #edit [isTitle]="true"
              fiTranslation="ALT_TEXT_REQUEST_LIST_EDIT" matTooltip="{{edit.dataset.matTooltip}}"
              matTooltipPosition="below" matTooltipClass='tooltip-style'>
          </button>
        }
        @if (userId === history?.Creator.Id && history?.ActionName === 'COMMENT_CREATE') {
          <button (click)="onDelete()">
            <img class="edit-button" alt="Edit" src="/assets/icons/new/trash-gray.svg" #delete [isTitle]="true"
              matTooltip="{{delete.dataset.matTooltip}}"
              matTooltipPosition="below" matTooltipClass='tooltip-style'>
            <span class="u-hidden-visually" fiTranslation="ALT_TEXT_COMMENT_DELETE"></span>
          </button>
        }
      </div>
    }
    @if (!isComposer) {
      <div class="comment-header">
        <span class="date">{{ dateTimeHelper.getFormattedDate(history?.CreTs) }}
          @if (getLanguage() !== 'it') {
            <span>
              <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_1"></span>
              <span>&nbsp;</span>
              <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
            </span>
          }
          @if (getLanguage() === 'it') {
            <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
          }
        </span>
        <span class="contact"> {{ history?.Creator.FirstName + ' ' + history?.Creator.LastName }}
        - {{ history?.Creator.Organisation }}</span>
        <span class="request-info"><span
        fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_DATE"></span> {{ history?.LeadNumber }}</span>
      </div>
    }
    @if (composerChanges?.length && isComposer) {
      <div class="comment-header">
        <span class="date">{{ dateTimeHelper.getFormattedDate(history?.CreTs) }}
          @if (getLanguage() !== 'it') {
            <span>
              <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_1"></span>
              <span>&nbsp;</span>
              <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
            </span>
          }
          @if (getLanguage() === 'it') {
            <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
          }
        </span>
        <span class="contact"> {{ history?.Creator?.FirstName + ' ' + history?.Creator?.LastName }}
        - {{ history?.Creator?.Organisation }}</span>
        <span class="request-info"><span
        fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_DATE"></span> {{ history?.LeadNumber }}</span>
      </div>
    }
    @if (composerChanges?.length && isComposer) {
      <fi-composer-changes-comments
        [composerChanges]="composerChanges"
        [history]="history"
        >
      </fi-composer-changes-comments>
    }
    @if (history.ActionName === 'DEADLINE_SERVICE'  && !isComposer) {
      <p>
        <span class="author">Per E-Mail für Angebotsübergabe vereinbart am </span>
        {{ dateTimeHelper.getHistoryFormattedDate(history.Deadline) }}
      </p>
    }
    @if (history.ActionName === 'LEAD_FORWARD_CONFIRM'  && !isComposer) {
      <p>
        <span class="action-icon">
          <img src="/assets/icons/new/persons.svg" alt="forward confirm">
        </span>
        <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_TAKEOVER"></span>
        {{ history.LeadEditor.FirstName }} {{ history.LeadEditor.LastName }}
      </p>
    }
    @if (history.ActionName === 'LEAD_CREATE' && !isComposer) {
      <div class="row">
        <span class="action-icon lead-create">
          <img src="assets/icons/new/plus.svg" alt="file-add">
        </span>
        <span class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_SECOND_ROW"></span>
        <p>
          @if (learCreateComment && !referrerUrl && !sourceDomain && !sourceDomainUTMParams.length) {
            <b fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_LABEL"></b><br>
          }
          <span class="is-html-snippet" [innerHTML]="comment"></span>
        </p>
        @if (eventsText) {
          <span class="author-text">, {{ eventsText }};</span>
        }
      </div>
      @if (events?.length) {
        <p class="consent-accredation">
          @for (item of events; track item) {
            @if (item.Name || item.Agency || item.PlannerKKZ) {
              <div class="eventData">
                @if (item.Name) {
                  <p>
                    <b class="author"><span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_EVENT"></span>: </b>
                    <span>{{ item.Name }}</span>
                  </p>
                }
                @if (item.Agency) {
                  <p>
                    <b class="author"><span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_AGENCY"></span>: </b>
                    <span>{{ item.Agency }}</span>
                  </p>
                }
                @if (item.PlannerKKZ) {
                  <p>
                    <b class="author"><span fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_ORGANISER"></span>: </b>
                    <span>{{ item.PlannerKKZ }}</span>
                  </p>
                }
              </div>
            }
          }
          <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_CONSENT_ACCREDITATION"></b>
          <span>&nbsp;</span>
          <span
          fiTranslation="{{consentAccredation ? 'REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_1' : 'REQUEST_CREATE_CONTACT_CHECKBOX_DISAGREE'}}"></span>
        </p>
      }
      @if (leadSerialNumber) {
        <p class="serial-number">
          <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_PRODUCT_NUMBER"></b>
          {{ leadSerialNumber }}
        </p>
      }
      @if (leadInvoiceNumber) {
        <p class="invoice-number">
          <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_INVOICE_NUMBER"></b>
          {{ leadInvoiceNumber }}
        </p>
      }
      @if (eventAttendees && eventAttendees.length) {
        <div class="event-attendees">
          <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_EVENT_PARTICIPANTS"></b>
          <b class="author">:</b>
          @for (event of eventAttendees; track event) {
            <p>
              <span>{{ event.FirstName }} {{ event.LastName }}, {{ event.Email }}</span>
            </p>
          }
        </div>
      }
      <p>
        <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_LEAD_TYPE"></b>
        {{ leadSourceText }}
      </p>
      @if (referrerUrl) {
        <p class="refererUrl">
          <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_REFERRER_URL"></b>
          <a class="refererUrlLink" target="_blank" [href]="referrerUrl">{{ referrerUrl }}</a>
        </p>
      }
      @if (sourceDomain) {
        <p class="sourceDomain">
          <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_SOURCE_DOMAIN"></b>
          <a class="sourceDomainLink" target="_blank" [href]="sourceDomain">{{ displaySourceDomain }}</a>
        </p>
      }
      @if (sourceDomainUTMParams && sourceDomainUTMParams.length > 0) {
        <div class="sourceDomainUtmParams">
          <p>
            <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_UTM_PARAMETERS"></b>
          </p>
          @for (item of sourceDomainUTMParams; track item) {
            <p>
              @if (item[1]) {
                @if (item[0] === CampaignKey) {
                  <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_CAMPAIGN"></b>
                }
                @if (item[0] === KKZKey) {
                  <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_KKZ"></b>
                }
                @if (item[0] === SourceKey) {
                  <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_SOURCE"></b>
                }
                @if (item[0] === MediumKey) {
                  <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_MEDIUM"></b>
                }
                @if (item[0] !== CampaignKey && item[0] !== KKZKey && item[0] !== SourceKey && item[0] !== MediumKey) {
                  <b class="author">
                    {{item[0]}}:
                  </b>
                }
                <span> {{ item[1] }}</span>
              }
            </p>
          }
        </div>
      }
      @if (history.Documents?.length) {
        <p>
          <b class="author file-create" fiTranslation="REQUEST_DETAIL_HISTORY_UPLOAD_FILE"></b>
          @for (doc of history.Documents; track doc) {
            <a [class.deleted]="doc.Deleted"
              [href]="doc.DownloadURL"
              (click)="downloadHelper.downloadDocument(doc, leadsDataService)"
              target="_blank" download [title]="doc.Name">
              <span class="file-create-content">
                <img alt="attachment" [src]="uploadHelper.getIconUrlFromMimeType(doc.MimeType, doc.ThumbnailURL)"> <span
              class="file-name">{{ doc.Name }}</span>
            </span>
          </a>
        }
      </p>
    }
  }
  @if (history?.ActionName === 'NEGOTIATION_CREATE' && !isComposer) {
    <p>
      <span class="action-icon negotiation-create">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_NEGOTIATION_CREATE"></span>
      {{ dateTimeHelper.getFormattedDate(history?.AppointmentDate) }}
      @if (history?.AppointmentStudio) {
        <span> <br>
          <span fiTranslation="REQUEST_DETAIL_HISTORY_APPOINTMENT_SHOWROOM"></span> {{ history.AppointmentStudio.KKZ }}
          - {{ history.AppointmentStudio.Name }} - {{ history.AppointmentStudio.City }}
        </span>
      }
    </p>
    <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
    </fi-history-note>
  }
  @if (history?.ActionName === 'COMPOSER_IMPORT' && !isComposer) {
    <p>
      <span class="action-icon negotiation-create">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author">Composer Import</span>
      {{ dateTimeHelper.getFormattedDate(history?.AppointmentDate) }}
    </p>
    <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
    </fi-history-note>
  }
  @if (history?.ActionName === 'LEAD_TAKEOVER' && !isComposer) {
    <p>
      <span class="action-icon negotiation-create">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_TAKEOVER"></span>
      {{ history?.LeadEditor.FirstName + ' ' + history?.LeadEditor.LastName }}
    </p>
    <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
    </fi-history-note>
  }
  @if (history?.ActionName === 'NEGOTIATION_MOVE' && !isComposer) {
    <p>
      <span class="action-icon negotiation-move">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_NEGOTIATION_MOVE"></span>
      {{ dateTimeHelper.getFormattedDate(history?.AppointmentDate) }}
    </p>
    <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
    </fi-history-note>
  }
  @if (history?.ActionName === 'LEAD_TYPE' && !isComposer) {
    <p>
      <span class="action-icon lead-type">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_TYPE"></span>
      {{ history?.LeadTypeText }}
    </p>
    <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
    </fi-history-note>
  }
  @if (history?.ActionName === 'LEAD_FORWARD' && !isComposer) {
    <p>
      <span class="action-icon">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_LEAD_FORWARD"></span>
      <span class="contact"> {{ history?.LeadEditor?.Organisation }}
        - {{ history?.LeadEditor?.FirstName + ' ' + history?.LeadEditor?.LastName }}
        @if (leadExternalDesc) {
          , {{ leadExternalDesc }}
        }
      </span>
    </p>
    <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
    </fi-history-note>
  }
  @if ((history?.ActionName === 'LEAD_PROCESS' || history?.ActionName === 'LEAD_PROCESS_EXT') && !isComposer) {
    <p>
      <span class="action-icon lead-process">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_LEAD_PROCESS"></span>
    </p>
    <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
    </fi-history-note>
  }
  @if (history?.ActionName === 'LEAD_FORWARD_UNDO' && !isComposer) {
    <p>
      <span class="action-icon">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_FORWARD_UNDO"></span>
      <span class="contact"> {{ history?.LeadEditor?.Organisation }}
      - {{ history?.LeadEditor?.FirstName + ' ' + history?.LeadEditor?.LastName }}</span>
    </p>
    <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
    </fi-history-note>
  }
  @if (history?.ActionName === 'LEAD_FORWARD_EXT' && !isComposer) {
    <p>
      <span class="action-icon lead-forward-ext">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_EXTERNAL_USER"></span>
      <span class="contact"> {{ history?.ExternalEmail }}</span>
    </p>
    <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
    </fi-history-note>
  }
  @if (history?.ActionName === 'LEAD_REMINDER_EXT' && !isComposer) {
    <p>
      <span class="action-icon lead-forward-ext">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_REMINDER_EXT"></span>
      <span class="contact"> {{ history?.ExternalEmail }}</span>
    </p>
    <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
    </fi-history-note>
  }
  @if (history?.ActionName === 'LEAD_NOT_INTERESTED' && !isComposer) {
    <p>
      <span class="action-icon">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_NOT_INTERESTED"></span>
      @if (notInterestedType && notInterestedType.IsFinstral) {
        <span
        class="contact"> {{ history?.LeadEditor?.FirstName ? history?.LeadEditor?.FirstName + ' ' + history?.LeadEditor?.LastName : '' }}</span>
      }
      @if (notInterestedType && !notInterestedType.IsFinstral && !contact?.Anonymized) {
        <span
        class="contact"> {{ contact.FirstName }} {{ contact.LastName }}</span>
      }
      @if (notInterestedType && !notInterestedType.IsFinstral && contact?.Anonymized) {
        <span class="anonymize"
        fiTranslation="REQUEST_DETAIL_HEADLINE_CONTACT_ANONYMIZE"></span>
      }
    </p>
    @if (notInterestedType) {
      <p>
        <b class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_REJECT_NOTE"></b>
        <span class="author-text">{{notInterestedType.Description}}</span>
        @if (priceDeviationText) {
          <span class="author-text">({{ priceDeviationText }})</span>
        }
      </p>
    }
    @if (notInterestedType && comment) {
      <p><span class="is-html-snippet" [innerHTML]="comment"></span></p>
    }
  }
  @if (history?.ActionName === 'LEAD_REOPEN' && !isComposer) {
    <p>
      <span class="action-icon">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_LEAD_REOPEN"></span>
    </p>
    @if (comment?.trim()) {
      <p>
        <b class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_REJECT_NOTE"></b>
        <span class="author-text is-html-snippet" [innerHTML]="comment"></span>
      </p>
    }
  }
  @if ((history?.ActionName === 'APPOINTMENT_CREATE' || history?.ActionName === 'APPOINTMENT_CREATE_EXTERNAL') && !isComposer) {
    <p>
      <span class="action-icon appointment-create">
        <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
      </span>
      @if (history?.ActionName === 'APPOINTMENT_CREATE') {
        <span class="author"
        fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_APPOINTMENT_CREATE"></span>
      }
      @if (history?.ActionName === 'APPOINTMENT_CREATE_EXTERNAL') {
        <span class="author"
        fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_APPOINTMENT_CREATE_EXTERNAL"></span>
      }
      {{ dateTimeHelper.getFormattedDate(history?.AppointmentDate) }}
      @if (history?.ActionName === 'APPOINTMENT_CREATE' && history?.AppointmentStudio) {
        <br>
          <span fiTranslation="REQUEST_DETAIL_HISTORY_APPOINTMENT_SHOWROOM"></span> {{ history.AppointmentStudio.KKZ }}
          - {{ history.AppointmentStudio.Name }} - {{ history.AppointmentStudio.City }}
        }
      </p>
      <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
      </fi-history-note>
    }
    @if ((history?.ActionName === 'CONSULTATION_CREATE' || history?.ActionName === 'CONSULTATION_CREATE_EXTERNAL') && !isComposer) {
      <p>
        <span class="action-icon appointment-create">
          <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
        </span>
        @if (history?.ActionName === 'CONSULTATION_CREATE') {
          <span class="author"
          fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_CONSULTATION_CREATE"></span>
        }
        @if (history?.ActionName === 'CONSULTATION_CREATE_EXTERNAL') {
          <span class="author"
          fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_CONSULTATION_CREATE_EXTERNAL"></span>
        }
        {{ dateTimeHelper.getFormattedDate(history?.AppointmentDate) }}
        @if (history?.ActionName === 'CONSULTATION_CREATE' && history?.AppointmentStudio) {
          <br>
            <span fiTranslation="REQUEST_DETAIL_HISTORY_APPOINTMENT_SHOWROOM"></span> {{ history.AppointmentStudio.KKZ }}
            - {{ history.AppointmentStudio.Name }} - {{ history.AppointmentStudio.City }}
          }
        </p>
        <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
        </fi-history-note>
      }
      @if ((history?.ActionName === 'LEAD_STATUS') && !isComposer) {
        <p>
          <span class="action-icon lead-status">
            <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
          </span>
          <span class="author">{{ history.ActionText }}</span>
          <span class="author">:</span>
          {{ history.Comment }}
        </p>
      }
      @if (history?.ActionName === 'APPOINTMENT_MOVE' && !isComposer) {
        <p>
          <span class="action-icon appointment-move">
            <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
          </span>
          <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_APPOINTMENT_MOVE"></span>
          {{ dateTimeHelper.getFormattedDate(history?.AppointmentDate) }}
        </p>
        <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
        </fi-history-note>
      }
      @if (history?.ActionName === 'LEAD_REMINDER' && !isComposer) {
        <p>
          <span class="action-icon lead-reminder">
            <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
          </span>
          <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_REMINDER"></span>
          {{ dateTimeHelper.getFormattedDate(history?.Deadline) }}
        </p>
        <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
        </fi-history-note>
      }
      @if (history?.ActionName === 'APPOINTMENT_REMINDER' && !isComposer) {
        <p>
          <span class="action-icon appointment-reminder">
            <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
          </span>
          <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_APPOINTMENT_REMINDER"></span>
          {{ dateTimeHelper.getFormattedDate(history?.Deadline) }}
        </p>
        <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
        </fi-history-note>
      }
      @if ((history?.ActionName === 'OFFER_SUBMIT' || history?.ActionName === 'OFFER_SUBMIT_EXTERNAL') && !isComposer) {
        <p>
          <span class="action-icon offer-submit">
            <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
          </span>
          @if (history?.ActionName === 'OFFER_SUBMIT') {
            <span class="author"
            fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_OFFER_MOVE"></span>
          }
          @if (history?.ActionName === 'OFFER_SUBMIT_EXTERNAL') {
            <span class="author"
            fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_OFFER_SUBMIT_EXTERNAL"></span>
          }
          {{ dateTimeHelper.getFormattedDate(history?.AppointmentDate) }}
          @if (history?.ActionName === 'OFFER_SUBMIT' && history?.AppointmentStudio) {
            <br>
              <span fiTranslation="REQUEST_DETAIL_HISTORY_APPOINTMENT_SHOWROOM"></span> {{ history.AppointmentStudio.KKZ }}
              - {{ history.AppointmentStudio.Name }} - {{ history.AppointmentStudio.City }}
            }
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'OFFER_DELAY' && !isComposer) {
          <p>
            <span class="action-icon offer-delay">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_OFFER_SUBMIT"></span>
            {{ dateTimeHelper.getFormattedDate(history?.AppointmentDate) }}
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'OFFER_MOVE' && !isComposer) {
          <p>
            <span class="action-icon offer-move">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_OFFER_DELAY"></span>
            {{ dateTimeHelper.getFormattedDate(history?.AppointmentDate) }}
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if ((history?.ActionName === 'ORDER_PLACED' || history?.ActionName === 'ORDER_PLACED_EXTERNAL') && !isComposer) {
          <p>
            <span class="action-icon">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            @if (history?.ActionName === 'ORDER_PLACED') {
              <span class="author"
              fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_ORDER_PLACED"></span>
            }
            @if (history?.ActionName === 'ORDER_PLACED_EXTERNAL') {
              <span class="author"
              fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_ORDER_PLACED_EXTERNAL"></span>
            }
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'PRIVACY_CHANGE') {
          <p>
            <span class="author" fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_MARKETING"></span><br>
            @if (history.ConsentMarketing) {
              <b class="privacy-policy"
              fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_1"></b>
              <span fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_AGREE"></span>
            }
            @if (!history.ConsentMarketing) {
              <b class="privacy-policy"
              fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_DISAGREE"></b>
              <span fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_DISAGREE"></span>
            }
          </p>
          <p>
            <span class="author" fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_MARKETING_THIRD_PARTIES"></span><br>
            @if (history.ConsentThirdParties) {
              <b class="privacy-policy"
              fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_1"></b>
              <span fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_THIRD_PARTIES_AGREE"></span>
            }
            @if (!history.ConsentThirdParties) {
              <b class="privacy-policy"
              fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_DISAGREE"></b>
              <span fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_THIRD_PARTIES_DISAGREE"></span>
            }
          </p>
        }
        @if (history?.ActionName === 'LEAD_BROKER_TAKEOVER' && !isComposer) {
          <p>
            <span class="action-icon negotiation-create">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_TAKEOVER"></span>
            {{ history?.LeadEditor?.FirstName }} {{ history?.LeadEditor?.LastName }}
            @if (history?.LeadEditor?.Organisation) {
              , {{ history.LeadEditor.Organisation }}
            }
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'LEAD_BROKER_START' && history?.LeadStateName === 'BROKERING_STARTED' && !isComposer && !isDealerPartner) {
          <p>
            <span class="action-icon appointment-reminder">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_START"></span>
          </p>
          @for (brokeringTarget of brokeringTargets; track brokeringTarget) {
            <div class="brokering-target-item">
              @if (brokeringTarget.displayId) {
                <span class="brokering-target-link"
                (click)="onBrokeringTargetClick(brokeringTarget.target.LeadId)">{{ brokeringTarget.displayId }}</span>
              }
              @if (brokeringTarget.leadEditor) {
                : {{ brokeringTarget.leadEditor }}
              }
            </div>
          }
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'LEAD_BROKER_SEND_WAVE' && history?.LeadStateName === 'BROKERING_STARTED' && !isComposer && !isDealerPartner) {
          <p>
            <span class="action-icon appointment-reminder">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_START_SECOND_WAVE"></span>
          </p>
          @for (brokeringTarget of brokeringTargets; track brokeringTarget) {
            <div class="brokering-target-item">
              @if (brokeringTarget.displayId) {
                <span class="brokering-target-link"
                (click)="onBrokeringTargetClick(brokeringTarget.target.LeadId)">{{ brokeringTarget.displayId }}</span>
              }
              @if (brokeringTarget.leadEditor) {
                : {{ brokeringTarget.leadEditor }}
              }
            </div>
          }
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'LEAD_BROKER_SUCCESS' && history?.LeadStateName === 'BROKERING_SUCCESS' && !isComposer && !isDealerPartner) {
          <p>
            <span class="action-icon">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_SUCCESS"></span>
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'LEAD_BROKER_ABORT' && history?.LeadStateName === 'BROKERING_PARTIAL' && !isComposer && !isDealerPartner) {
          <p>
            <span class="action-icon">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_PARTIAL"></span>
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'LEAD_BROKER_ABORT' && history?.LeadStateName === 'BROKERING_FAILED' && !isComposer && !isDealerPartner) {
          <p>
            <span class="action-icon">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_FAILED"></span>
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'LEAD_BROKER_ABORT' && history?.LeadStateName === 'BROKERING_ABORTED' && !isComposer && !isDealerPartner) {
          <p>
            <span class="action-icon">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_ABORTED"></span>
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'LEAD_BROKER_START' && history?.LeadStateName === 'BROKERING_STARTED' && !isComposer && isDealerPartner) {
          <p>
            <span class="action-icon">
              <img [src]="actionHelper.getActionIconUrl('LEAD_FORWARD')" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_STATUS_LEAD_FORWARD"></span>
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'LEAD_REJECT' && !isComposer) {
          @if (history?.LeadStateName === 'BROKERED_LEAD_FAILED') {
            <p>
              <span class="action-icon">
                <img [src]="actionHelper.getActionIconUrl('LEAD_REJECT')" alt="action-icon">
              </span>
              <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_ASSIGNMENT_FAILED"></span>
            </p>
            <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
            </fi-history-note>
          } @else {
            <p>
              <span class="action-icon">
                <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
              </span>
              <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_REJECT"></span>
              <span class="contact"> {{ history?.LeadEditor?.Organisation }}
              - {{ history?.LeadEditor?.FirstName + ' ' + history?.LeadEditor?.LastName }}</span>
            </p>
            <p>
              <b class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_REJECT_NOTE"></b>
              {{ history?.RejectReasonText }}
            </p>
            <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
            </fi-history-note>
          }
        }
        @if (history?.ActionName === 'LEAD_BROKER_LEAD_ACCEPTED' && !isComposer) {
          <p>
            <span class="action-icon negotiation-create">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            <span class="author" fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_LEAD_BROKER_TAKEOVER"></span>
            {{ brokerAcceptedByText }}
          </p>
          @if (brokerAcceptedTarget?.displayId) {
            <div class="brokering-target-item">
              <span class="brokering-target-link"
              (click)="onBrokeringTargetClick(brokerAcceptedTarget.target.LeadId)">{{ brokerAcceptedTarget.displayId }}</span>
            </div>
          }
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'COMMENT_CREATE' && !isComposer) {
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
          @if (history?.Documents?.length) {
            <p>
              <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_UPLOAD_FILE"></b>
              @for (doc of history?.Documents; track doc) {
                <a [class.deleted]="doc.Deleted" class="document-link"
                  [href]="doc.DownloadURL"
                  target="_blank" download [title]="doc.Name">
                  <span class="image-container">
                    @if (doc) {
                      <img #fileType
                        alt=""
                        title=""
                        (click)="downloadHelper.downloadDocument(doc, leadsDataService, true)"
                        [isTitle]="true" fiTranslation="ALT_TEXT_IMAGE_OPEN_TAB"
                        [src]="uploadHelper.getIconUrlFromMimeType(doc.MimeType, doc.ThumbnailURL)"
                        matTooltip="{{fileType.dataset.matTooltip}}"
                        matTooltipPosition="below" matTooltipClass='tooltip-style'>
                    }
                  </span>
                  <span class="doc-name-content" style="max-width: {{getMaxWidth(documentName)}}"
                    (click)="downloadHelper.downloadDocument(doc, leadsDataService)">
                    <span class="doc-name-text" #documentName>{{ docName(doc.Name) }}</span>
                    <span class="type-name">{{ docTypeName(doc.Name) }}</span>
                  </span>
                  <span class="type-name-content">
                  </span>
                </a>
              }
            </p>
          }
        }
        @if ((history?.ActionName === 'PLANNER_INVITE_EXT' || history?.ActionName === 'PLANNER_INVITE_MOVE' || history?.ActionName === 'PLANNER_INVITE') && !isComposer) {
          <p>
            <span class="action-icon lead-type">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            {{ history?.ActionText }}: {{ history?.AppointmentStudio ? (history?.AppointmentStudio.Name + ' - ' + history?.AppointmentStudio.Address) + (history?.AppointmentDate ? ', ' : '') : '' }}
            {{ history?.AppointmentDate ? dateTimeHelper.getFormattedDate(history?.AppointmentDate) : '' }}
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if ((history?.ActionName === 'PLANNER_VISIT_EXT' || history?.ActionName === 'PLANNER_VISIT_MOVE' || history?.ActionName === 'PLANNER_VISIT') && !isComposer) {
          <p>
            <span class="action-icon lead-type">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            {{ history?.ActionText }}: {{
            history?.AppointmentAddress ? (history?.AppointmentAddress.Address + ', '
            + history?.AppointmentAddress.ZipCode + ' ' + history?.AppointmentAddress.City + ', '
            + history?.AppointmentAddress.CountryCode) + (history?.AppointmentDate ? ', ' : '') : ''
            }}
            {{ history?.AppointmentDate ? '' + dateTimeHelper.getFormattedDate(history?.AppointmentDate) : '' }}
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
        @if (history?.ActionName === 'COMPENDIUM_SEND' || history?.ActionName === 'COMPENDIUM_ALLOW' || history?.ActionName === 'COMPENDIUM_DENY' || history?.ActionName === 'COMPENDIUM_DENIED' || history?.ActionName === 'COMPENDIUM_REQUEST' && !isComposer) {
          <p>
            <span class="action-icon">
              <img [src]="actionHelper.getActionIconUrl(history?.ActionName)" alt="action-icon">
            </span>
            @if (history?.ActionName === 'COMPENDIUM_SEND') {
              <span
              fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPENDIUM_MAGIC_LINK_SENT"></span>
            }
            @if (history?.ActionName === 'COMPENDIUM_ALLOW') {
              <span
              fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPENDIUM_ACCESS_GRANTED"></span>
            }
            @if (history?.ActionName === 'COMPENDIUM_REQUEST') {
              <span
              fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPENDIUM_REQUESTED"></span>
            }
            @if (history?.ActionName === 'COMPENDIUM_DENY') {
              <span
              fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPENDIUM_ACCESS_DENIED"></span>
            }
            @if (history?.ActionName === 'COMPENDIUM_DENIED') {
              <span
              fiTranslation="REQUEST_DETAIL_LEAD_HISTORY_COMPENDIUM_ACCESS_REQUESTED_DENIED"></span>
            }
          </p>
          <fi-history-note [text]="comment" [isEdited]="isCommentEdited" (textEdited)="onEditFinished($event)">
          </fi-history-note>
        }
      </div>
    }

    @if (history?.ActionName === 'LEAD_CREATE' && !isComposer) {
      <div [class.hidden-from-view]="isHidden(true)" class="comment" id="thirdHistoryComment">
        <div class="comment-header">
          <span class="date">{{ dateTimeHelper.getFormattedDate(history?.CreTs) }}
            @if (getLanguage() !== 'it') {
              <span>
                <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_1"></span>
                <span>&nbsp;</span>
                <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
              </span>
            }
            @if (getLanguage() === 'it') {
              <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
            }
          </span>
          <span class="contact"> {{ history?.Creator.FirstName + ' ' + history?.Creator.LastName }}
          - {{ history?.Creator.Organisation }}</span>
          <span class="request-info"><span
          fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_DATE"></span> {{ history?.LeadNumber }}</span>
        </div>
        <p>
          <span class="author" fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_MARKETING_THIRD_PARTIES"></span><br>
          @if (history?.ConsentThirdParties) {
            <b class="privacy-policy"
            fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_1"></b>
            <span fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_THIRD_PARTIES_AGREE"></span>
          }
          @if (!history?.ConsentThirdParties) {
            <b class="privacy-policy"
            fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_DISAGREE"></b>
            <span fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_THIRD_PARTIES_DISAGREE"></span>
          }
        </p>
        <p>
          <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_PRIVACY_DOCUMENTS"></b>
          {{ dateTimeHelper.getFormattedDate(history?.CreTs) }}
          @if (privacyDocument) {
            <a
              [class.deleted]="privacyDocument.Deleted"
              [href]="privacyDocument.DownloadURL"
              (click)="downloadHelper.downloadDocument(privacyDocument, leadsDataService)"
              target="_blank" download>
              <img alt="attachment"
                [src]="uploadHelper.getIconUrlFromMimeType(privacyDocument.MimeType)"> {{ privacyDocument.Name }}
              </a>
            }
          </p>
        </div>
        <div [class.hidden-from-view]="isHidden(true)" class="comment" id="secondHistoryComment">
          <div class="comment-header">
            <span class="date">{{ dateTimeHelper.getFormattedDate(history?.CreTs) }}
              @if (getLanguage() !== 'it') {
                <span>
                  <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_1"></span>
                  <span>&nbsp;</span>
                  <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
                </span>
              }
              @if (getLanguage() === 'it') {
                <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
              }
            </span>
            <span class="contact"> {{ history?.Creator.FirstName + ' ' + history?.Creator.LastName }}
            - {{ history?.Creator.Organisation }}</span>
            <span class="request-info"><span
            fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_DATE"></span> {{ history?.LeadNumber }}</span>
          </div>
          <p>
            <span class="author" fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_MARKETING"></span><br>
            @if (history?.ConsentMarketing) {
              <b class="privacy-policy"
              fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_1"></b>
              <span fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_AGREE"></span>
            }
            @if (!history?.ConsentMarketing) {
              <b class="privacy-policy"
              fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_DISAGREE"></b>
              <span fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_DISAGREE"></span>
            }
          </p>
          <p>
            <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_PRIVACY_DOCUMENTS"></b>
            {{ dateTimeHelper.getFormattedDate(history?.CreTs) }}
            @if (privacyDocument) {
              <a
                [class.deleted]="privacyDocument.Deleted"
                [href]="privacyDocument.DownloadURL"
                (click)="downloadHelper.downloadDocument(privacyDocument, leadsDataService)"
                target="_blank" download>
              <img alt="attachment"
                [src]="uploadHelper.getIconUrlFromMimeType(privacyDocument.MimeType)"> {{ privacyDocument.Name }}
              </a>
            }
          </p>
        </div>
        <div [class.hidden-from-view]="isHidden(true)" class="comment" id="firstHistoryComment">
          <div class="comment-header">
            <span class="date">{{ dateTimeHelper.getFormattedDate(history?.CreTs) }}
              @if (getLanguage() !== 'it') {
                <span>
                  <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_1"></span>
                  <span>&nbsp;</span>
                  <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
                </span>
              }
              @if (getLanguage() === 'it') {
                <span fiTranslation="REQUEST_DETAIL_HISTORY_TIME_FROM_BEFORE_TIME_2"></span>
              }
            </span>
            <span class="contact"> {{ history?.Creator.FirstName + ' ' + history?.Creator.LastName }}
            - {{ history?.Creator.Organisation }}</span>
            <span class="request-info"><span
            fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_DATE"></span> {{ history?.LeadNumber }}</span>
          </div>
          <p>
            <span class="author" fiTranslation="REQUEST_DETAIL_HISTORY_CONSENT_PRIVACY"></span><br>
            <b class="privacy-policy" id="privacyTextAgreementText"
            fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_1"></b>
            <span fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_2"></span>
          </p>
          <p>
            <b class="author" fiTranslation="REQUEST_DETAIL_HISTORY_LEAD_CREATE_PRIVACY_DOCUMENTS"></b>
            {{ dateTimeHelper.getFormattedDate(history?.CreTs) }}
            @if (privacyDocument) {
              <a
                [class.deleted]="privacyDocument.Deleted"
                [href]="privacyDocument.DownloadURL"
                (click)="downloadHelper.downloadDocument(privacyDocument, leadsDataService)"
                target="_blank" download>
              <img alt="attachment"
                [src]="uploadHelper.getIconUrlFromMimeType(privacyDocument.MimeType)"> {{ privacyDocument.Name }}
              </a>
            }
          </p>
        </div>
      }
